import { render } from "./TokenizePropertyForm.vue?vue&type=template&id=0dc1dc62"
import script from "./TokenizePropertyForm.vue?vue&type=script&lang=js"
export * from "./TokenizePropertyForm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__